import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/project-request-empty.png'


const _withScopeId = n => (_pushScopeId("data-v-1e26f5ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "historic_project"
}
const _hoisted_2 = {
  key: 0,
  class: "historic_project__content"
}
const _hoisted_3 = {
  key: 1,
  class: "empty-screen md:!tw-pt-[24px] md:!tw-mt-0"
}
const _hoisted_4 = { class: "empty-screen__inner" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"empty-screen__image md:!tw-ml-0 md:!tw-mb-[24px]\" data-v-1e26f5ce><img src=\"" + _imports_0 + "\" alt=\"\" data-v-1e26f5ce></div><div class=\"empty-screen__header\" data-v-1e26f5ce><h2 data-v-1e26f5ce>You currently don&#39;t have any Draft Historic project.</h2><p data-v-1e26f5ce>Kick off your historic project with unparalleled speed.</p></div><div class=\"empty-screen__content\" data-v-1e26f5ce><div class=\"empty-screen__content-item\" data-v-1e26f5ce><div class=\"mdi mdi-check-circle\" data-v-1e26f5ce></div><p data-v-1e26f5ce><strong data-v-1e26f5ce>Dispute protection</strong> as standard</p></div><div class=\"empty-screen__content-item\" data-v-1e26f5ce><div class=\"mdi mdi-check-circle\" data-v-1e26f5ce></div><p data-v-1e26f5ce>Deposits secured <strong data-v-1e26f5ce>in Escrow</strong></p></div><div class=\"empty-screen__content-item\" data-v-1e26f5ce><div class=\"mdi mdi-check-circle\" data-v-1e26f5ce></div><p data-v-1e26f5ce> Verified trade contractors <strong data-v-1e26f5ce>in your local area</strong></p></div></div>", 3)
const _hoisted_8 = { class: "empty-screen__footer" }

import { useStore } from "vuex";
import { ref, computed, onMounted, watch } from "vue";
import { WORKSTATION } from "@/store/modules/workstation";
import PropertyListComponent from "./PropertyListComponent.vue";
import Loader from "@/core/components/common/Loader.vue";
import { JOBS_STORE } from "@/store/modules/jobs";
import DraftHistoricalProjectCard from "./DraftHistoricalProjectCard .vue";
import { parseJSON } from "@/core/utils/common";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import { PROJECT_STORE } from "@/store/modules/project";

export default /*#__PURE__*/_defineComponent({
  __name: 'DraftHistoricProjectComponent',
  setup(__props) {

const store = useStore();
const loading = ref(false);

const isOpenNewProject = ref(false);
const isHistoricalDraftProjectFlow = ref(false);

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const historicalDraftProjects = computed(
  () => store.getters[`${JOBS_STORE}/getHistoricalDraftProjects`]
);

const currentHistoricalProject = ref();
const onClickProject = (project: any) => {
  const draftHistoricalProjectData = parseJSON(
    project.draftHistoricalProjectData
  );
  if (draftHistoricalProjectData.formData) {
    store.dispatch(
      `${JOB_TEMPLATE_STORE}/setFormData`,
      draftHistoricalProjectData.formData
    );
  }
  if (draftHistoricalProjectData.estimateForm) {
    store.dispatch(
      `${JOB_TEMPLATE_STORE}/setEstimateForm`,
      draftHistoricalProjectData.estimateForm
    );
  }
  if (draftHistoricalProjectData.projectSpecialisms) {
    store.dispatch(
      `${PROJECT_STORE}/setProjectSpecialisms`,
      draftHistoricalProjectData.projectSpecialisms
    );
  }
  if (draftHistoricalProjectData?.historicalProjectForm?.attachments) {
    const attachments =
      draftHistoricalProjectData?.historicalProjectForm?.attachments;
    const uploadAttachments = draftHistoricalProjectData?.uploadedAttachment;

    attachments.forEach((item: any) => {
      if (!item.isUploaded) {
        const uploadAttachment = uploadAttachments.find(
          (attachment: any) =>
            attachment.originalName === item.uploadedImages.name
        );
        if (uploadAttachment) {
          item.uploadedImages.url =
            uploadAttachment.src || item.uploadedImages.url;
          item["isUploaded"] = true;
          item["attachment"] = uploadAttachment.attachment;
          item["originalName"] = uploadAttachment.originalName;
          item["publicUrl"] = uploadAttachment.publicUrl;
        }
      }
    });
    store.dispatch(`${PROJECT_STORE}/setProjectAttachments`, attachments);
  }
  currentHistoricalProject.value = project;
  isHistoricalDraftProjectFlow.value = true;
  store.commit(`${JOBS_STORE}/saveHistoricalDraftProject`, project);
  openNewProject();
};
onMounted(async () => {
  await store.dispatch(`${JOBS_STORE}/setDraftHistoricalProjects`);
});

const openNewProject = () => {
  isOpenNewProject.value = true;
};
const onClickBackButton = async () => {
  isOpenNewProject.value = false;
  await store.dispatch(`${JOBS_STORE}/setDraftHistoricalProjects`);
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isOpenNewProject.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (historicalDraftProjects.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historicalDraftProjects.value, (item) => {
                  return (_openBlock(), _createBlock(DraftHistoricalProjectCard, {
                    key: item.id,
                    job: item,
                    onClick: ($event: any) => (onClickProject(item))
                  }, null, 8, ["job", "onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!historicalDraftProjects.value?.length && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple",
                      onClick: openNewProject,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Start a new Historic project ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(Loader, { class: "tw-mt-[250px]" }, null, 512), [
            [_vShow, loading.value]
          ])
        ]))
      : _createCommentVNode("", true),
    (isOpenNewProject.value)
      ? (_openBlock(), _createBlock(PropertyListComponent, {
          key: 1,
          onOnClickBackButton: onClickBackButton,
          isHistoricalDraftProjectFlow: isHistoricalDraftProjectFlow.value
        }, null, 8, ["isHistoricalDraftProjectFlow"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})